interface CharCounterProps {
  length: number;
  max: number;
}

/** "n/max" counter that turns red once the text exceeds its limit. */
export const CharCounter = ({ length, max }: CharCounterProps) => (
  <span className={`text-xs ${length > max ? 'text-error' : 'text-gray-500'}`}>
    {length}/{max}
  </span>
);
